export default "__VITE_ASSET__DSS2gxnO__"